import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { Loader, Modal, Button } from 'sa-ui';

import messages from './networkPanelMessages';
import * as actions from './networkPanelActions';
import { resolveNetworkPanelSsoUrl } from './networkPanelHelpers';

import './NetworkPanelContainer.scss';

const NetworkPanelContainer = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [pendingOpen, setPendingOpen] = useState(true);

  useEffect(() => {
    if (!props.networkPanelSSOUrlFetched && !props.loadingNetworkPanelSSO) {
      props.getNetworkPanelSsoUrl();
    }
  }, []);

  useEffect(() => {
    if (
      pendingOpen &&
      props.networkPanelSSOUrlFetched &&
      resolveNetworkPanelSsoUrl(props.networkPanelSSOUrl) &&
      !props.networkPanelSSOError
    ) {
      setShowModal(true);
      setPendingOpen(false);
    }
  }, [
    pendingOpen,
    props.networkPanelSSOUrlFetched,
    props.networkPanelSSOUrl,
    props.networkPanelSSOError,
  ]);

  const isLoading = props.loadingNetworkPanelSSO || !props.networkPanelSSOUrlFetched;
  const iframeUrl = resolveNetworkPanelSsoUrl(props.networkPanelSSOUrl);
  const hasUrl = Boolean(iframeUrl) && !props.networkPanelSSOError;

  function handleOpenModal() {
    if (iframeUrl && !props.networkPanelSSOError) {
      setShowModal(true);
      return;
    }
    setPendingOpen(true);
    props.getNetworkPanelSsoUrl();
  }

  function handleCloseModal() {
    setShowModal(false);
    props.getNetworkPanelSsoUrl();
  }

  function handleRetry() {
    setPendingOpen(true);
    props.getNetworkPanelSsoUrl();
  }

  return (
    <div className="network-panel">
      <Loader show={isLoading && !showModal} />
      <Row>
        <Col md={12}>
          <h5 className="title">{props.intl.formatMessage(messages.title)}</h5>
        </Col>
      </Row>
      <hr />

      {!isLoading && props.networkPanelSSOError && (
        <div className="network-panel__empty">
          <p className="network-panel__empty-message">
            {props.intl.formatMessage(messages.loadError)}
          </p>
          <Button primary onClick={handleRetry}>
            {props.intl.formatMessage(messages.retry)}
          </Button>
        </div>
      )}

      {!isLoading && !props.networkPanelSSOError && !showModal && (
        <div className="network-panel__empty">
          <Button primary onClick={handleOpenModal}>
            {props.intl.formatMessage(messages.reopen)}
          </Button>
        </div>
      )}

      <Modal show={showModal && hasUrl} onClose={handleCloseModal} large>
        {typeof iframeUrl === 'string' && (
          <iframe
            src={iframeUrl}
            frameBorder="0"
            title={props.intl.formatMessage(messages.title)}
          />
        )}
      </Modal>
    </div>
  );
};

NetworkPanelContainer.propTypes = {
  intl: PropTypes.object.isRequired,
  getNetworkPanelSsoUrl: PropTypes.func.isRequired,
  networkPanelSSOUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  loadingNetworkPanelSSO: PropTypes.bool,
  networkPanelSSOUrlFetched: PropTypes.bool,
  networkPanelSSOError: PropTypes.bool,
};

const mapStateToProps = ({ networkPanel }) => ({
  ...networkPanel,
});

export default compose(
  injectIntl,
  connect(mapStateToProps, actions),
)(NetworkPanelContainer);
